import React from 'react';
// Constants
import {
  KeywordsPages,
  LocationCity,
  MainTitle,
} from '../../utils/Constants';
// Data
import {
  galleryPageAdditionalMeta,
  galleryPageStructuredData,
} from '../../utils/data/MetaData';
// Images
import GalleryHeaderImage from '../../assets/images/headers/gallery-barbie-style-pink-header.png';
import SammiMainImage from '../../assets/images/temp/mistress-sammmi-smith-gorgeous-smoking-crouched.png';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import FooterComponent from '../../components/footer/FooterComponent';
import GeneralHeader from '../../components/general/GeneralHeader';
import GalleryPageMainContainer from '../../components/gallery/GalleryPageMainContainer';

function Gallerypage() {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Gallery'
        desc={`Mistress Sammi Smith - Trans Dominatrix. Explore my gallery and experience the art of domination in ${LocationCity}.`}
        keywords={KeywordsPages}
        additionalMeta={galleryPageAdditionalMeta}
        structuredData={galleryPageStructuredData}
      />

      {/* Page */}
      <div className='grid min-h-screen bg-colour2 dark:bg-colour2 text-colour1 dark:text-colour1 w-full h-full overflow-hidden font-poppins'>
        <div className='grid h-fit'>
          {/* Navigation */}
          <Navbar />
          <GeneralHeader
            headerMainImage={GalleryHeaderImage}
            headerMobileImage={GalleryHeaderImage}
            mainTitle={`${MainTitle}`}
            subtitle={`My Sinful Sex Life in Color!`}
            mainImage={SammiMainImage}
          />
        </div>

        {/* Main page content */}
        <GalleryPageMainContainer />

        {/* Footer */}
        <div className='mt-12'>
          <FooterComponent />
        </div>
      </div>
    </>
  );
}

export default Gallerypage;
